import React from 'react';
import gfglogo from '../assets/gfg_logo.png';
import { Link } from 'react-router-dom';
import '../styles/footer.css';
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* GFG Logo */}
        <div className="footer-section">
              <img
                src={gfglogo}
                alt="GeeksforGeeks Logo"
                className="logo-image"
              />
        </div>
        <div className='navitems'>
        <Link className='navithings' id='footertext' to='/'>Home</Link>
            <Link className='navithings' id='footertext' to='/Questions'>Problems</Link>
            {/* <Link className='navithings' id='footertext' to='#events'>Sponsors</Link> */}
            <Link className='navithings' id='footertext' to='/team'>Team</Link>
        </div>
        {/* Social Handles Section */}
        <div className="footer-section">
          <h3 className="section-title">Social Handles</h3>
          <div className="social-icons">
            <Link to="https://www.instagram.com/gfg_viit" target="_blank" rel="noopener noreferrer">
              <img
                src="https://img.icons8.com/?size=100&id=32323&format=png&color=000000"
                alt="Instagram"
                className="social-icon"
              />
            </Link>
            <Link to="https://www.linkedin.com/company/gfg-viit" target="_blank" rel="noopener noreferrer">
              <img
                src="https://img.icons8.com/?size=100&id=13930&format=png&color=000000"
                alt="LinkedIn"
                className="social-icon"
              />
            </Link>
          </div>
        </div>

        {/* Contact Section */}
        <div className="footer-section contact">
          <h3 className="section-title">Contact Us</h3>
          <p>gfg@viit.ac.in</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          Made with <span className="heart">♥</span> by{' '}
          <Link to={'/contributors'} className="footer-link" id='footerlink'>
            GFG VIIT Web Team
          </Link>
        </p>
        <p>© Copyright GFG VIIT. All Rights Reserved</p>
      </div>
    </footer>
  );
};

export default Footer;
